/* import __COLOCATED_TEMPLATE__ from './editor-styles.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();